import { render } from "./Edit.vue?vue&type=template&id=13fb4da7"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Products/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13fb4da7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13fb4da7', __exports__)) {
    api.reload('13fb4da7', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=13fb4da7", () => {
    api.rerender('13fb4da7', render)
  })

}


export default __exports__